/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import _map from 'lodash/map'
import {isSaadaFn} from 'hiya-common/src/utils/hooks/useIsSaada'
import {useSelector} from 'react-redux'

export enum ChannelStatusEnum {
  不生效 = 0,
  生效 = 1,
}

export enum ChannelTypeEnum {
  官方 = 0,
  周卡 = 1,
  华为 = 2,
  第三方 = 3,
  薪资转金币 = 4,
}

export interface ProductsListInterface {
  list: Array<any>
  coins: number
  last_coins_stage: number
  is_ra_customer: boolean
  countries: Array<{
    code: number
    name: string
    flag: string
  }>
  default_country: {
    code: number
    name: string
    flag: string
  }
  is_white_tag?: boolean
  has_third_pay?: boolean
  has_week_card: boolean
  refund_amount?: number //	欠款金额
  return_amount?: number //	归还金额
  debt_amount?: number //	还欠款多少
  ra_recharge_rate?: number //	币商充值比例
  is_login_black?: boolean //	是否还在封禁中
}

interface InitialStateType {
  wallet?: ProductsListInterface
  defaultChannelIds?: Array<string>
}
const initialState: InitialStateType = {
  wallet: {
    list: [],
    last_coins_stage: 0,
    coins: 0,
    is_ra_customer: false,
    countries: [],
    default_country: {
      code: 0,
      name: '',
      flag: '',
    },
    has_week_card: false,
  },
  defaultChannelIds: [],
}

export const createRechargeOrderV2 = createAsyncThunk(
  'PaymentBlock/createRechargeOrderV2',
  async (
    params: {
      product_id: string
      pay_method_id: number
      from: string
      code: number
      source: string
    },
    store: any
  ) => {
    const {otherInfo, deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/pay/create_order_for_refund',
      {
        ...otherInfo,
        ...params,
        mid: otherInfo.h_m || deviceinfo.h_m,
        ...store.getState().env?.otherInfo,
      },
      {
        store,
        // xcHideLog: true,
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export const getProductsList = createAsyncThunk(
  'PaymentBlock/getProductsList',
  async (params: any = {}, store: any) => {
    const resp = await http.post(
      '/live/pay/get_recharge_products_list_for_refund',
      {
        ...params,
        before_recharged: 1,
        ...store.getState().env?.otherInfo,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_merchant_channel_list = createAsyncThunk(
  'PaymentBlock/merchant_list',
  async (p: any, store: any) => {
    const {otherInfo} = store.getState().env
    const isSaada = isSaadaFn(store.getState().env)
    const resp = await http.post(
      `/live/pay/${
        isSaada
          ? 'get_recharge_agency_list_for_refund'
          : 'merchant_list_for_refund'
      }`,
      {offset: 0, page_size: 1, ...store.getState().env?.otherInfo},
      {
        store,
        xcErrorToast: true,
      }
    )
    return _map(resp.data.data?.channels || [], (it) => it.channel)
  }
)

export const PaymentBlockSlice = createSlice({
  name: 'PaymentBlock',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProductsList.fulfilled, (state, action) => {
      const res = action.payload
      const list = _map(res?.list, (item) => {
        return {
          ...item,
          // 列表里的currency和ThirdPartyPaySt里不一致时，用列表里的currency覆盖ThirdPartyPaySt的currency
          list: _map(item?.list, (li: any) => {
            if (li?.currency !== item?.currency) {
              li.currency = item.currency
            }
            return li
          }),
        }
      })
      // 防止已经保存的数据被完全清除
      Object.assign(state.wallet, {...res, list})
    })
    builder.addCase(get_merchant_channel_list.fulfilled, (state, action) => {
      Object.assign(state, {
        defaultChannelIds: action.payload,
      })
    })
  },
})
export default PaymentBlockSlice.reducer
export const PaymentBlockAction = PaymentBlockSlice.actions

export const usePaymentBlockState = () => {
  const data = useSelector((state) => {
    return state.Animal_Ocelot_pyBlock
  })
  return data
}
